import { gql } from '@apollo/client'

export const CHAT_INBOX = gql`
  query ChatInbox(
    $mode: String
    $unread: Boolean
    $tags: [Int]
    $dateFrom: String
    $dateTo: String
    $search: String
    $assignedUserId: Int
    $offset: Int
    $limit: Int
  ) {
    chatInbox(
      mode: $mode
      unread: $unread
      tags: $tags
      dateFrom: $dateFrom
      dateTo: $dateTo
      search: $search
      assignedUserId: $assignedUserId
      offset: $offset
      limit: $limit
    ) {
      items {
        id
        fullName
        phone
        avatar
        unreadCount
        assignedTo
        assignedToName
        configSource
        activeChannels
        activeChannelsDetail {
          channelType
          phoneNumber
        }
        lastMessage {
          content
          createdAt
          direction
          channel
          receivedViaChannel {
            id
            provider
            channelType
            phoneNumber
            webhookToken
          }
        }
        tags {
          id
          name
          color
        }
      }
      total
      configSource
    }
  }
`

export const CHAT_HISTORY = gql`
  query ChatHistory($contactId: Int!) {
    chatHistory(contactId: $contactId) {
      messages {
        id
        direction
        content
        status
        createdAt
        channel
        metadata
        receivedViaChannel {
          id
          provider
          channelType
          phoneNumber
          webhookToken
        }
      }
      total
      configSource
    }
  }
`

export const CHAT_TAGS = gql`
  query ChatTags {
    chatTags {
      id
      name
      color
    }
  }
`

export const AVAILABLE_CHANNELS = gql`
  query AvailableChannels {
    availableChannels {
      id
      source
      label
      type
      whatsappNumber
      smsNumber
    }
  }
`

export const INBOX_USERS = gql`
  query InboxUsers {
    inboxUsers {
      id
      fullName
      email
    }
  }
`
